import { BaseObject } from "@adgate/common/types/base-object.type";
import { CommercialOffice } from "@adgate/common/types/commercial-office.type";

export class Agency extends BaseObject
{
    externalId!: string;
    contactEmail!: string;
    offices!: CommercialOffice[];
}